import { Typography } from '@iheartjane/reefer';
import type { ProductCategory, ProductKind } from '@iheartjane/types';
import { clsx } from 'clsx';

import { useCustomLanguage } from '@jane/bloom/hooks/useCustomLanguage';

import { getProductCategoryLabel } from './getProductCategoryLabel';

import styles from './productCategoryLabel.module.css';

export type CategoryProps = {
  category?: ProductCategory | null;
  className?: string;
  kind: ProductKind;
};

export const ProductCategoryLabel = ({
  category,
  className,
  kind,
}: CategoryProps) => {
  const customLanguage = useCustomLanguage();
  const label = getProductCategoryLabel({ category, customLanguage, kind });

  return (
    <Typography className={className} variant="small-body-regular" maxLines={1}>
      {category ? (
        <span
          className={clsx({
            [styles['cbdLabel']]: category === 'cbd',
            [styles['hybridLabel']]: category === 'hybrid',
            [styles['indicaLabel']]: category === 'indica',
            [styles['sativaLabel']]: category === 'sativa',
          })}
        >
          {label}
        </span>
      ) : (
        label
      )}
    </Typography>
  );
};
